import {LinkedOrderRecord} from '../../components/settings/orders/linked-order.record';
import {setMetadata} from '../../core/data-source/data-source';
import {HttpCrudDataSource, RestResponseRecord} from '../../core/data-source/http-crud.data-source';
import {fromJson, toJson} from '../../core/data-source/json.mapper';
import {HttpService, httpService, IHttpRequestOptions} from '../../core/services/http.service';
import {OrderRecord} from '../../records/order.record';

export class OrderCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/orders';

    async getConsignmentId(): Promise<string> {
        return httpService
            .get(this.apiPath + `/consignment/generatedId`)
            .then((response: any) => response.data.rows.pop());
    }

    async getListLinkedOrder(params: any): Promise<LinkedOrderRecord[]> {
        return httpService
            .get(this.apiPath + `/getOrderIdsByType?` + HttpService.paramsToQuery(params))
            .then((response: any) => {
                return response.data.rows.map((item: any) => fromJson(LinkedOrderRecord, item));
            });
    }

    async checkOrdersWithReference(orderReference: string, id?: number): Promise<any> {
        return httpService
            .get(
                this.apiPath +
                    `/check_orders_with_reference?orderReference=` +
                    encodeURIComponent(orderReference) +
                    (id ? '&orderId=' + id : '')
            )
            .then((response: any) => {
                return response.data.rows ? response.data.rows[0] : null;
            });
    }

    //Order tab
    async all(filter: any, options?: IHttpRequestOptions): Promise<OrderRecord[]> {
        return httpService.post(this.apiPath + '/listWithFilter?', toJson(filter), options).then((response: any) => {
            if (response.data.success) {
                return setMetadata(
                    response.data.rows.map((v: any) => fromJson(this.recordClass, v)),
                    fromJson(RestResponseRecord, response.data)
                );
            } else {
                throw response.data.errors;
            }
        });
    }
}
